import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import Translate from 'translate';
import async from 'async';

import ChannelCaseService from 'services/ChannelCaseService';
import { FormGroup, Text, Textarea, Select } from 'components/FormElements';
import { toggleAlertError, toggleLoading } from 'stores/actions';
import { required, validPhoneLEC, email } from 'constants/InputErrors';
import IncmsService from 'services/IncmsService';

class SendServicesLECModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      incidentSubTypes:[],
      incidentTypes:[],
      landmark: null
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.setState( { landmark: null } );
      this.getData()
    }
  }

  getData() {
    const { toggleAlertError, toggleLoading, activeAccount } = this.props;
    toggleLoading( true );
    const data = {};
    data.contractNumber = activeAccount.account || '';
    IncmsService.getContractNumberInfo( data ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) toggleAlertError( response.errors );

      const info = (response.data && response.data.length >=1 )? response.data[0] : null ;
      this.setState( {  
                      emailAddress: info ? _.trim(info.emailAddress) : '',
                      mobileNumber: info ? _.trim(info.mobileNumber) : '',
                      phone2: info ? _.trim(info.phone2) : '',
                      phone3: info ? _.trim(info.phone3) : '',
                    } )
      
    } );
  }

  getIncidentSubTypes( id ) {
    const { toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );

    IncmsService.getIncidentSubTypes( id ).then( ( response ) => {
      toggleLoading( false );
      if ( response.errors ) toggleAlertError( response.errors );
      this.setState( {incidentSubTypes: response.data } )
      
    } );
  }

  submitForm( data ) {
    const { onClose, activeAccount, toggleAlertError, toggleLoading } = this.props;
    toggleLoading( true );
    data.customerId = activeAccount.idCustomer;

    IncmsService.updateSendServiceLEC( data ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );
      this.props.toggleAlertError( <Translate id="dataSaved"/>  );
      onClose()
    } )
  }

  render() {
    const {emailAddress, mobileNumber, phone2, phone3} = this.state;
    const { onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             closeOnOverlayClick={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="sendServices"/></h5>

        <Form onSubmit={this.submitForm}
              defaultValues={{ 
                emailAddress:  emailAddress,
                mobileNumber: mobileNumber,
                phone2: phone2,
                phone3: phone3,

                }}
              validate={( values ) => ( {
                emailAddress: values.emailAddress ? email(values.emailAddress) : null,
                mobileNumber: required( values.mobileNumber ) ? required( values.mobileNumber )
                  : validPhoneLEC( values.mobileNumber ),
                phone2: values.phone2 ? validPhoneLEC( values.phone2 ) : null,
                phone3: values.phone3 ? validPhoneLEC( values.phone3 ) : null,
              } )}
        >
          {( { getValue, submitForm } ) =>
            <form onSubmit={submitForm}>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="email"/></label>
                  <Text field="emailAddress" className="form-control"/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="mobileNumber"/></label>
                  <Text field="mobileNumber" className="form-control" placeholder="mobileNumber"/>
                </FormGroup>
              </div>
              <div className="row">
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone2"/></label>
                  <Text field="phone2" className="form-control" placeholder="phone2"/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="phone3"/></label>
                  <Text field="phone3" className="form-control" placeholder="phone3"/>
                </FormGroup>
              </div>


              <div className="text-right">
                <button className="btn btn-info"><Translate id="submit"/></button>
              </div>
            </form>
          }
        </Form>
      </Modal>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message, msgToCopy ) => {
    dispatch( toggleAlertError( message, msgToCopy ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( SendServicesLECModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SendServicesLECModal/index.js